import router from "@/router";
import { apolloClient } from "@/plugins/apollo";
import { CURRENT_ACCOUNT, CREATE_ACCOUNT } from "@/graphql";

export default {
  create: ({ commit, dispatch }, payload) => {
    commit("setLoading", true, { root: true });
    dispatch("clearErrors", null, { root: true });
    return apolloClient
      .mutate({
        mutation: CREATE_ACCOUNT,
        variables: payload
      })
      .then(({ data }) => {
        dispatch("authentication/success", data.createAccount, { root: true });
        router.push({ name: "Account" });
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        dispatch("setErrors", error, { root: true });
      });
  },
  current: ({ commit }) => {
    return apolloClient
      .query({
        query: CURRENT_ACCOUNT
      })
      .then(({ data }) => {
        if (data.currentAccount) {
          commit("setCurrent", data.currentAccount);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
};
